import { createContext, useContext, useEffect, useState } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => { try { return JSON.parse(localStorage.getItem('cnm_user') || 'null'); } catch { return null; } });
  const [token, setToken] = useState(() => localStorage.getItem('cnm_token'));
  const [ready, setReady] = useState(false);

  useEffect(() => {
    if (token) axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    else delete axios.defaults.headers.common['Authorization'];
    setReady(true);
  }, [token]);

  const persist = (t, u) => {
    localStorage.setItem('cnm_token', t);
    localStorage.setItem('cnm_user', JSON.stringify(u));
    setToken(t); setUser(u);
  };

  const login = async (payload) => {
    const { data } = await axios.post(`${API}/auth/login`, payload);
    persist(data.access_token, data.user);
    return data.user;
  };

  const signup = async (payload) => {
    const { data } = await axios.post(`${API}/auth/signup`, payload);
    persist(data.access_token, data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem('cnm_token');
    localStorage.removeItem('cnm_user');
    setToken(null); setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, token, ready, login, signup, logout }}>{children}</AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
